<template>
  <div class="dashboard-container min-h-screen bg-gray-100 dark:bg-gray-900">
    <!-- Sidebar -->
    <aside class="sidebar">
      <div class="logo">EasyRight</div>
      <nav>
        <a href="#" class="nav-item active">📄 My Documents</a>
        <a href="#" class="nav-item">⚙️ Settings</a>
        <a href="#" class="nav-item">🔒 Security</a>
        <a href="#" class="nav-item">📞 Support</a>
        <a href="/" class="nav-item logout">🚪 Logout</a>
      </nav>
    </aside>

    <!-- Main Content -->
    <main class="content">
      <header class="header">
        <div>
          <h1 class="title">Dashboard</h1>
          <p class="subtitle">Manage your legal documents efficiently</p>
        </div>
        <div class="profile">
          <img
            src="https://i.pravatar.cc/265"
            alt="User Avatar"
            class="avatar"
          />
          <span class="username">John Doe</span>
        </div>
      </header>

      <!-- Conditional Rendering -->
      <section v-if="!selectedComponent" class="grid">
        <div class="card">
          <h3>📜 AGB</h3>
          <p>Last updated: 31 Mar 2025</p>
          <button class="btn-primary" @click="navigateToGenerator('agb')">
            Manage
          </button>
        </div>
        <div class="card">
          <h3>🔏 DSGVO</h3>
          <p>Last updated: 31 Mar 2025</p>
          <button class="btn-primary" @click="navigateToGenerator('dsgvo')">
            Manage
          </button>
        </div>
        <div class="card">
          <h3>🏢 Impressum</h3>
          <p>Last updated: 31 Mar 2025</p>
          <button class="btn-primary" @click="navigateToGenerator('impressum')">
            Manage
          </button>
        </div>
        <div class="card">
          <h3>📋 My Documents</h3>
          <p>Last updated: 20 Jan 2025</p>
          <button
            class="btn-primary"
            @click="navigateToGenerator('other-docs')"
          >
            Manage
          </button>
        </div>
      </section>

      <!-- Loaded Component -->
      <button
        v-if="selectedComponent"
        class="btn-secondary"
        @click="navigateBack"
      >
        ← Back to Dashboard
      </button>
      <component :is="selectedComponent" v-if="selectedComponent"></component>
    </main>
  </div>
</template>

<script>
import AgbGenerator from "@/views/AGBGenerator.vue"; // AGB-Komponente importieren
import DsgvoGenerator from "@/views/DSVGOGenerator.vue";
import ImpressumGenerator from "@/views/ImpressumShop.vue";

export default {
  name: "DashboardPage",
  data() {
    return {
      selectedComponent: null,
    };
  },
  methods: {
    navigateToGenerator(topic) {
      const components = {
        agb: AgbGenerator,
        dsgvo: DsgvoGenerator,
        impressum: ImpressumGenerator,
      };
      this.selectedComponent = components[topic] || null;
    },
    navigateBack() {
      this.selectedComponent = null;
    },
  },
};
</script>

<style scoped>
/* Ensure container is a row layout */
.dashboard-container {
  display: flex;
  flex-direction: row;
}

/* Sidebar */
.sidebar {
  width: 250px;
  background: #232323;
  color: #fff;
  padding: 20px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.logo {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
}

.nav-item {
  display: block;
  padding: 12px;
  margin: 5px 0;
  border-radius: 8px;
  text-decoration: none;
  color: #ccc;
  transition: 0.3s;
}

.nav-item:hover,
.nav-item.active {
  background: #333;
  color: #fff;
}

.logout {
  margin-top: auto;
  color: #ccc;
}

.logout:hover {
  background: #666;
}

/* Main Content */
.content {
  flex: 1;
  padding: 40px;
  background: #fff;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.title {
  font-size: 28px;
  font-weight: bold;
  color: #000;
}

.subtitle {
  color: #555;
}

/* User Profile */
.profile {
  display: flex;
  align-items: center;
  background: #f0f0f0;
  padding: 8px 12px;
  border-radius: 20px;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}

.username {
  font-weight: 500;
  color: #000;
}

/* Cards Layout */
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.card {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: 0.3s;
}

.card h3 {
  font-size: 20px;
  margin-bottom: 10px;
  color: #000;
}

.card p {
  color: #555;
  margin-bottom: 15px;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

/* Buttons */
.btn-primary {
  background: #333;
  color: #fff;
  padding: 8px 12px;
  border-radius: 6px;
  font-weight: bold;
  border: none;
  transition: 0.3s;
}

.btn-primary:hover {
  background: #555;
  cursor: pointer;
}

.btn-secondary {
  background: #ddd;
  color: #333;
  padding: 8px 12px;
  border-radius: 6px;
  font-weight: bold;
  border: none;
  transition: 0.3s;
  margin-top: 20px;
}

.btn-secondary:hover {
  background: #bbb;
  cursor: pointer;
}
</style>
